import React,{useEffect,useState}from'react';
async function api(u,o){const r=await fetch(u,{credentials:'include',headers:{'Content-Type':'application/json'},...o}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
export default function AdminCertificates(){
  const[rows,setRows]=useState([]),[e,setE]=useState(''),[msg,setMsg]=useState(''),[dates,setDates]=useState({});
  const load=()=>api('/api/certificates').then(setRows).catch(x=>setE(x.message));
  useEffect(()=>{load()},[]);
  const key=r=>r.employee_id+'-'+r.course_id;
  const issue=async r=>{
    try{const j=await api('/api/certificates/issue',{method:'POST',body:JSON.stringify({employee_id:r.employee_id,course_id:r.course_id,completion_date:dates[key(r)]||r.default_completion_date})});
      setE('');setMsg('Certificate '+j.certificate.cert_no+' issued to '+r.employee_name+'.');load()}
    catch(x){setE(x.message)}
  };
  const voidIt=async r=>{
    const reason=window.prompt('Why is this certificate being voided?');if(!reason)return;
    try{await api('/api/certificates/'+r.certificate.id+'/void',{method:'POST',body:JSON.stringify({reason})});setE('');setMsg('Certificate voided.');load()}
    catch(x){setE(x.message)}
  };
  return <div className="p-5 space-y-5">
    <header>
      <a href="/admin/training" className="text-sm underline text-slate-600">← Training Dashboard</a>
      <h1 className="text-3xl font-black">Training Certificates</h1>
      <p className="text-slate-600">A <b>PCA Onboarding</b> certificate is ready when all modules are passed and all 13 skills on the checklist are signed off as Pass. An <b>Initial Dementia Care</b> certificate is ready when all modules are passed and competency is confirmed on the Dementia Training page.</p>
    </header>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    {msg&&<div className="bg-emerald-50 p-3 rounded-lg text-emerald-800">{msg}</div>}
    <section className="rounded-2xl border bg-white p-4 overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead><tr className="border-b text-slate-500"><th className="p-2">Employee</th><th className="p-2">Certificate</th><th className="p-2">Status</th><th className="p-2"></th></tr></thead>
        <tbody>
          {rows.map(r=><tr key={key(r)} className="border-b align-top">
            <td className="p-2 font-bold">{r.employee_name}</td>
            <td className="p-2">{r.type_label}<div className="text-xs text-slate-500">{r.course_title}</div></td>
            <td className="p-2">{r.certificate
              ?<span className="rounded-full bg-emerald-100 px-2 py-1 text-xs font-bold text-emerald-800">Issued {r.certificate.issued_date} · {r.certificate.cert_no}</span>
              :r.eligible
                ?<span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-bold text-blue-800">Ready to issue</span>
                :<span className="text-slate-600">{r.reasons.join(' ')}</span>}</td>
            <td className="p-2 space-x-2 whitespace-nowrap">
              {r.certificate&&<><a className="rounded border px-3 py-2 text-xs font-bold" href={'/certificate/'+r.certificate.id}>View / Print</a><button className="text-xs text-red-700 underline" onClick={()=>voidIt(r)}>Void</button></>}
              {!r.certificate&&r.eligible&&<>
                <input type="date" className="border p-2 text-xs" title="Completion date" value={dates[key(r)]||r.default_completion_date} onChange={x=>setDates({...dates,[key(r)]:x.target.value})}/>
                <button className="rounded bg-slate-900 px-3 py-2 text-xs font-bold text-white" onClick={()=>issue(r)}>Issue certificate</button></>}
            </td>
          </tr>)}
          {!rows.length&&<tr><td className="p-3 text-slate-500" colSpan={4}>No assigned courses with certificates yet.</td></tr>}
        </tbody>
      </table>
    </section>
  </div>
}
